// extracted by mini-css-extract-plugin
export default {"configOptions":"styles_configOptions__HhZCi","customSelectBox":"styles_customSelectBox__Ww7QP","serialNumberInput":"styles_serialNumberInput__X+nUf"};